import { useMutation } from '@apollo/client';

import { UpdateUserTinderJoinedInput } from '../../apollo/__generated__/graphql';
import { UPDATE_USER_TINDER_JOINED } from '../graphql/mutation/updateUserTinderJoinedMutation.graphql';

export const useUpdateUserTinderJoinedMutation = () => {
  const [mutate] = useMutation(UPDATE_USER_TINDER_JOINED);

  const updateUserTinderJoined = (
    updateUserTinderJoinedInput: UpdateUserTinderJoinedInput,
  ) => {
    mutate({
      variables: {
        updateUserTinderJoinedInput,
      },
    });
  };

  return { updateUserTinderJoined };
};
